import { Package } from './Package';
import { VatPackagePrice } from './VatPackagePrice';
import { BracketMarkupPriceDTO } from '../../dto';
import { MgPackageClassCode } from '@retail/products/types';

interface BracketMarkupPriceProps {
  calculationPackage: Package;
  packageSalesPrices?: VatPackagePrice[];
}

export class BracketMarkupPrice {
  calculationPackage: Package;
  packageSalesPrices?: VatPackagePrice[];

  constructor(props: BracketMarkupPriceProps) {
    this.calculationPackage = props.calculationPackage;
    this.packageSalesPrices = props.packageSalesPrices;
  }

  static fromDto = (dto: BracketMarkupPriceDTO): BracketMarkupPrice =>
    new BracketMarkupPrice({
      calculationPackage: Package.fromDto(dto.calculationPackage),
      packageSalesPrices: dto.packageSalesPrices?.map(VatPackagePrice.fromDto),
    });

  getPriceForClassCode = (classCode: MgPackageClassCode): VatPackagePrice | undefined => {
    return this.packageSalesPrices?.find(
      (packagePrice) => packagePrice.supplierItemPackage.classCode === classCode
    );
  };
}
